import React from 'react'
import { Grid, Typography, Divider, Paper } from '@mui/material'
import Masonry from '@mui/lab/Masonry';
import '../../../styles/report.css'
import DynamicComponent from '../DynamicComponent'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "60",
    "Visible": "1",
    "Label": "Health Assessment Responses",
    "ComponentType": "STANDARD MASONRY SECTION",
    "Sections": [
        {
            "ComponentType": "MUST BE DYNAMIC COMPONENT"
        }
    ]
}
        
*/

const MasonrySection = (props) => {

    const OrderedSections = [...props.component.Sections].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredSections = OrderedSections.filter((a) => { return a.Visible === '1' })
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    return (
        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid
                        container
                        direction="row"
                        alignItems="top"
                        justifyContent="center"
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            <Typography variant="h5" align="center">{props.component.Label}</Typography>
                        </Grid>
                        <Grid item xs={12} m={1}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={1} >
                                {
                                    FilteredSections && FilteredSections.map((displayValues, index) => {
                                        return (
                                            <DynamicComponent component={displayValues} key={index} />
                                        )
                                    })
                                }
                            </Masonry>
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>
        </Grid>
    )
}

export default MasonrySection